import { Navigate } from 'react-router-dom';

/** Certified copy outputs is the only working evidence tile. */
export function EvidenceCertificatesHubPage() {
  return <Navigate to="/custodian/evidence/certified-copies" replace />;
}
